import { combineReducers } from 'redux';

import preferencesReducer from './preferences/reducer';
import mediaReducer from './media/reducer';
import eventsReducer from './events/reducer';
import identitiesReducer from './identities/reducer';
import settings from './settings/reducer';
import geofences from './geofences/reducer';
import assetMonitoringReducer from './assetMonitoring';
import tagsReducer from './tags';
import { globalSettingsReducer } from './globalsettings';
import { layoutTemplateModularFullscreenReducer } from './layoutTemplateModularFullscreen/duck';

import {eventReviewReducer} from './review/duck';
import permissionsReducer from './permissions/duck';

export default combineReducers({
    preferences: preferencesReducer,
    media: mediaReducer,
    events: eventsReducer,
    identities: identitiesReducer,
    settings,
    geofences,
    tags: tagsReducer,
    globalSettings: globalSettingsReducer,
    assetMonitoring: assetMonitoringReducer,
    layoutTemplateModularFullscreenSharedState: layoutTemplateModularFullscreenReducer,

    eventReview: eventReviewReducer,
    permissions: permissionsReducer,
});
